function isNull (object) {
  return object === null;
}

function isUndefined (object) {
  // eslint-disable-next-line
    return typeof object === typeof void 0;
}

function isNullOrUndefined (object) {
  return isNull(object) || isUndefined(object);
}

Vue.component('kuheiga-image-carousel', {

  delimiters: ['${', '}'],

  inject: {
    itemId: {
      default: null
    }
  },

  props: {
    imageUrlAccessor:
        {
          type: String,
          default: 'url'
        },
    pluginPath:
        {
          type: String,
          default: ''
        }
  },

  data () {
    return {
      currentItem: 0
    };
  },

  computed:
    {
      currentVariation () {
        return this.$store.getters[`${this.itemId}/currentItemVariation`];
      },

      carouselImages () {
        return this.$options.filters.itemImages(
          this.currentVariation.images,
          'urlPreview'
        ).slice(0, this.maxQuantity);
      },
      singleImages () {
        return this.$options.filters.itemImages(
          this.currentVariation.images,
          this.imageUrlAccessor
        ).slice(0, this.maxQuantity);
      }
    },

  watch: {
    currentVariation:
        {
          handler (val, oldVal) {
            if (val !== oldVal) {
              setTimeout(() => {
                this.reInitialize();
              }, 1);
            }
          },
          deep: true
        }
  },

  mounted () {
    this.$nextTick(() => {
      this.loadLightbox().then(() => {
        this.initCarousel();
        this.initThumbCarousel();
      })
        .catch(event => {
          console.log('error while loading lightbox', event);
        });
    });
  },

  methods: {
    getImageCount () {
      return this.carouselImages.length;
    },

    reInitialize () {
      const $owl = $(this.$refs.single);

      $owl.trigger('destroy.owl.carousel');
      $owl.html($owl.find('.owl-stage-outer').html()).removeClass('owl-loaded');
      $owl.find('.owl-item').remove();

      const $thumbs = $(this.$refs.thumbs);

      $thumbs.slick('unslick');

      this.initCarousel();
      this.initThumbCarousel();
    },

    initCarousel () {
      const imageCount = this.getImageCount();
      const carouselSettings = {
        autoHeight: true,
        dots: this.showDots,
        items: 1,
        lazyLoad: true,
        rewind: true,
        margin: 10,
        mouseDrag: imageCount > 1,
        nav: imageCount > 1,
        navClass: [
          'owl-single-item-nav left carousel-control',
          'owl-single-item-nav right carousel-control'
        ],
        navContainerClass: '',
        navText: [
          '<i class="owl-single-item-control fa fa-chevron-left" aria-hidden="true"></i>',
          '<i class="owl-single-item-control fa fa-chevron-right" aria-hidden="true"></i>'
        ],
        smartSpeed: 350,
        onChanged: event => {
          const $thumb = $(this.$refs.thumbs);

          if ($thumb.length > 0 && $thumb[0].slick) {
            $thumb.slick('slickGoTo', event.page.index);
          }
        }
      };

      if (this.animationStyle !== 'standard') {
        carouselSettings.animateOut = this.animationStyle;
      }

      $(this.$refs.single).on('initialized.owl.carousel', event => {
        if (!this.isTouchDevice()) {
          const driftImgs = this.$refs.single.querySelectorAll('img');
          const pane = this.$refs.driftpanel;

          driftImgs.forEach(img => {
            new Drift(img, {
              hoverBoundingBox: true,
              paneContainer: pane,
              zoomFactor: 2,
              inlinePane: false,
              handleTouch: false
            });
          });
        }
      });

      $(this.$refs.single).owlCarousel(carouselSettings);

      if (!isNullOrUndefined(window.lightbox)) {
        lightbox.option({
          wrapAround: true,
          albumLabel: this.$translate('Ceres::Template.singleItemLightboxImageShown')
        });
      }

      $(this.$refs.single).on('changed.owl.carousel', event => {
        this.currentItem = event.page.index;
      });
    },

    isTouchDevice () {
      return (('ontouchstart' in window) ||
                (navigator.maxTouchPoints > 0) ||
                (navigator.msMaxTouchPoints > 0));
    },

    initThumbCarousel () {
      $(this.$refs.thumbs).slick({
        vertical: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        verticalSwiping: true,
        infinite: false,
        prevArrow: "<i class='slick-prev-i fas fa-angle-up'></i>",
        nextArrow: "<i class='slick-next-i fas fa-angle-down'></i>"
      });

      const this2 = this;

      $(this.$refs.thumbs).find('.slick-slide').on('click', function (event) {
        const slideClicked = $(this).attr('data-slick-index');

        this2.goTo(slideClicked);
      });
    },

    goTo (index) {
      const $owl = $(this.$refs.single);

      $owl.trigger('to.owl.carousel', [
        index,
        350
      ]);
    },

    getAltText (image) {
      return image && image.alternate ? image.alternate : this.$options.filters.itemName(this.currentVariation);
    },

    getItemName () {
      return this.$options.filters.itemName(this.currentVariation);
    },

    loadLightbox () {
      return new Promise((resolve, reject) => {
        const script = document.querySelector('script#lightboxscript');

        if (!isNullOrUndefined(script)) {
          resolve();
        } else {
          const script = document.createElement('script');

          script.type = 'text/javascript';
          script.id = 'lightboxscript';
          script.src = `${this.pluginPath}/js/dist/lightbox.min.js`;

          script.addEventListener('load', () => resolve(), false);
          script.addEventListener('error', event => reject(event), false);

          document.body.appendChild(script);
        }
      });
    }
  },

  template: `<div itemscope itemtype="http://schema.org/Thing" class="single-item-kh-carousel">
    <div id="thumb-carousel" class="slick-thumb-carousel" ref="thumbs">
      <div v-for="(imagePreview, index) in carouselImages">
        <img
            :data-index="index"
            :src="imagePreview.url"
            :alt="getAltText(imagePreview)"
            :title="getItemName()"
        >
      </div>
    </div>
    <div id="single-carousel" class="owl-carousel owl-theme owl-single-item" ref="single">
      <div v-for="image in singleImages">
          <a :href="image.url" data-lightbox="single-big-image-gallery">
              <img class="owl-lazy" :data-src="image.url" :data-zoom="image.url" :alt="getAltText(image)" :title="getItemName()" itemprop="image">
          </a>
      </div>
    </div>
    <div class="drift-pane" ref="driftpanel"></div>
  </div>`
});

$(function () {
  $('body').on('click', '.widget-filter-all-fl .facet-item .filter-toggle', function () {
    $('.widget-filter-all-fl .facet-item .collapse').collapse('hide');
  });
  setInterval(function () {
    $('.widget-filter-all-fl .facet-item .collapse.init').removeClass('init').collapse('hide');
  }, 200);
  $('body').on('click', '#toogle-filters', function () {
    $('#filterCollapse').slideToggle('slow');
  });

  $('body').on('change', '#CfourItemQuestionsForm [name="productid"]', function () {
    const msgfield = $(this).parent().find('[name="message"]');

    if (msgfield.length && msgfield.val().length <= 0) {
      msgfield.val('Artikel ID: ' + $(this).val());
    }
  });
  $('#CfourItemQuestionsForm [name="productid"]').change();

  /* <div class="model-button-container"><button type="button" class="btn btn-primary show-3d-modal">
        <span>View in 3D</span>
    </button></div> */
  $('body').on('click', '.show-3d-modal', function () {
    const itemModal = $('#item3dModal');

    const modelSrc = $(this).attr('data-model');

    itemModal.find('model-viewer').attr('src', modelSrc);

    itemModal.modal('show');
  });

  if (window.location.href.indexOf('#3dModel') != -1) {
    $('.show-3d-modal').trigger('click');
  }
});
